import { CustomizationsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<CustomizationsModel>('/ipad/children/customizations');
export default api;
